module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.getStaticPath(_vm.footerLogo),
      "alt": "Footer Logo"
    }
  }), _vm._v(" "), _c('social-media-buttons', {
    attrs: {
      "media-links": _vm.mediaLinks
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up col-4 text-right"
  }, [_c('button', {
    staticClass: "button-primary button-up",
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrow-up"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-8 navigation-mobile-bg"
  }, [_c('footer-navigation')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-12"
  }, [_c('footer-journals-family')], 1)])])])]), _vm._v(" "), _c('footer-copyright')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31482fea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/footer-area/FooterAreaComponent.vue
// module id = 1416
// module chunks = 1